// @ts-nocheck
// Cache the site header detection per page so multiple consumers on the same page reuse a
// single DOM query. Keyed by pathname so the value refreshes on navigation.
let cachedHeaderPresence: { path: string; hasHeader: boolean } | undefined;

/**
 * Returns whether the site header (`<header>`) is rendered on the current page.
 * Defaults to `true` during SSR (no `document`) to keep server/client first render consistent.
 */
const getHasHeader = () => {
    if (typeof document === "undefined") {
        return true;
    }

    const path = window.location.pathname;
    if (cachedHeaderPresence?.path === path) {
        return cachedHeaderPresence.hasHeader;
    }

    const hasHeader = Boolean(document.querySelector("header"));
    cachedHeaderPresence = { path, hasHeader };
    return hasHeader;
};

export default getHasHeader;
